import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

import { RouterLink, RouterLinkActive } from "@angular/router";

export interface NavigationTab {
  label: string;
  link: string;
}

@Component({
  selector: "app-navigation-tabs",
  templateUrl: "./navigation-tabs.component.html",
  styleUrls: ["./navigation-tabs.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive],
})
export class NavigationTabsComponent {
  @Input() public tabs: NavigationTab[];
}
